export default __webpack_public_path__ + "static/media/prize-3.960d3f6c.webp";